import { render, staticRenderFns } from "./HorizontalAlignmentField.vue?vue&type=template&id=07caf41a"
import script from "./HorizontalAlignmentField.vue?vue&type=script&lang=js"
export * from "./HorizontalAlignmentField.vue?vue&type=script&lang=js"
import style0 from "./HorizontalAlignmentField.vue?vue&type=style&index=0&id=07caf41a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports